
const ua = navigator.userAgent
export const isDev = process.env.NODE_ENV === 'development'
export const inMobile = /Mobi|Android|iPhone/i.test(ua)
export const inApp = ua.toLowerCase().indexOf('lightos') > -1



// WEBPACK FOOTER //
// ./src/gtn/const/index.js